// The migration endpoints answer a refusal with `{ error, reason, detail }` — a translated
// sentence plus the specifics (which checklist items are missing, what Meta said). Model
// validation failures come back from Rails as `{ message }` instead, so both shapes are
// unwrapped here.
export const migrationApiError = (error, fallback) => {
  const data = error?.response?.data;
  const message = data?.error || data?.message;

  if (!message) return fallback;

  return data.detail ? `${message}: ${data.detail}` : message;
};
